import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamCustomerLogsDownloadRoute } from '@jira/router-routes__eoc-team-customer-logs-routes/src/eocTeamCustomerLogsDownloadRoute.tsx';
import { downloadResources as customerLogsDownloadResources } from '@atlassian/eoc-customer-logs/resources';
import type { Route } from '@atlassian/react-resource-router';
import {
	CustomerLogsDownloadPage,
	LazyCustomerLogsDownLoad,
} from './ui/spa/eoc/customer-logs/index.tsx';

export const eocTeamCustomerLogsDownloadRouteEntry: Route = createEntry(
	eocTeamCustomerLogsDownloadRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomerLogsDownloadPage,
		layout: globalSettingsLayout,
		resources: [
			...jiraSpaResources(),
			getConsolidationStateResource(),
			...customerLogsDownloadResources(),
		],
		forPaint: [LazyCustomerLogsDownLoad],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
